var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('styled-select',{staticClass:"year-selector separated-caret",attrs:{"options":_vm.options,"value":parseInt(_vm.year)},on:{"input":_vm.selected}})}
var staticRenderFns = []

export { render, staticRenderFns }